<template>
    <SideFormSection>
        <template #title>
            <span class="text-red-500">Delete Company</span>
        </template>
        <template #subtitle>
            Close this account and all resources associated with it.
        </template>
        <template #rawContent>
            <Card
                title="Delete Company"
                iconName="trash"
            >
                <template #content>
                    <Alert
                        type="danger"
                        title="WARNING!"
                    >
                        You will also lose access to any other accounts you were
                        invited to, and this action is irreversible, we won't be
                        able to bring back your account once deleted.
                    </Alert>
                </template>
                <template #actions>
                    <DeleteCompanyButtonModal />
                </template>
            </Card>
        </template>
    </SideFormSection>
</template>

<script setup lang="ts">
    import SideFormSection from '@/Shared/Component/SideFormSection.vue'
    import Card from '@/Shared/Component/Card.vue'
    import Alert from '@/Shared/Component/Alert.vue'
    import DeleteCompanyButtonModal from '@/App/Company/Component/DeleteCompanyButtonModal.vue'
</script>
